import { render, staticRenderFns } from "./HotImagePlaceholder.vue?vue&type=template&id=896229b4&"
import script from "./HotImagePlaceholder.vue?vue&type=script&lang=js&"
export * from "./HotImagePlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports